import { get as _get } from 'lodash';
import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { getAllProjects } from '../../common/services/projectService';

const startLoading = createAction('projects/loading/begin');

export const initialState = {
  loadingStatus: 'init',
  projectsList: [],
};

export const loadProjectsThunk = createAsyncThunk(
  'projects/getAll',
  async (payload, thunkApi) => {
    thunkApi.dispatch(startLoading());

    const projects = await getAllProjects();

    return projects;
  },
  {
    condition: (payload, { getState }) => {
      const { projects } = getState();
      const { loadingStatus } = projects;

      if (loadingStatus === 'loading') {
        return false;
      }

      return true;
    },
  }
);

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    fetchProjectsEnded: (state, action) => ({
      ...state,
      projectsList: action.payload,
      loadingStatus: 'fulfilled',
    }),
  },
  extraReducers: {
    [startLoading]: (state) => ({
      ...state,
      loadingStatus: 'loading',
    }),
    [loadProjectsThunk.fulfilled]: (state, { payload }) => ({
      projectsList: payload,
      loadingStatus: 'fulfilled',
    }),
  },
});
export default projectsSlice.reducer;

// Actions
export const { fetchProjectsEnded } = projectsSlice.actions;

// Selectors
export const getProjectsList = (state) =>
  _get(state, ['projects', 'projectsList'], []);

export const getProjectsLoading = (state) =>
  _get(state, ['projects', 'loadingStatus'], []);

export const getIsProjectsLoading = (state) =>
  getProjectsLoading(state) === 'loading';
